<glxy-checkbox
  label="{{ 'AUTOMATIONS.EDITOR.FILTERS.ADD_CONDITIONS_LABEL' | translate }}"
  [formControl]="addConditionCheckboxForm"
></glxy-checkbox>
<div class="filters" *ngIf="addConditionCheckboxForm.value">
  <ng-container *ngFor="let filterStep of triggerFilters; let index = index">
    <automata-workflow-step-filter
      [filterStep]="filterStep"
      [selectedTaskDefinitionId]="selectedTaskDefinitionId"
      [showClose]="triggerFilters.length > 1"
      [displayInternalFilters]="showInternalTriggers$ | async"
      (removed)="remove(index)"
    ></automata-workflow-step-filter>
    <span class="filter-operator" *ngIf="index !== triggerFilters.length - 1">
      {{ 'AUTOMATIONS.EDITOR.FILTERS.COMPARISON.AND' | translate }}
    </span>
  </ng-container>
  <a (click)="addMore()" class="more">
    {{ 'AUTOMATIONS.EDITOR.FILTERS.ADD_ANOTHER_FILTER' | translate }}
  </a>
</div>
